import { useMemo } from 'react';
import * as React from 'react';

import Radio from '@/components/elements/Form/Radio';
import { BetType } from '@/lib/apollo/types/gen/graphql';
import { getBetTypeName } from '@/lib/race';

import { Wrapper } from '../style';

interface BetTypeRadioProps {
  betType: BetType;
  buttonList: { betType: BetType; disabled?: boolean }[];
  isModifyingDisabled: (
    key: 'betMethod' | 'betType' | 'wheelAxis',
    arg: string,
  ) => boolean;
  onChange: (checked: boolean, betType: BetType) => void;
}

const BetTypeRadio: React.FC<BetTypeRadioProps> = ({
  betType,
  buttonList,
  isModifyingDisabled,
  onChange,
}) => {
  const disabled = (item: { betType: BetType; disabled?: boolean }) =>
    useMemo(
      () => item.disabled || isModifyingDisabled('betType', item.betType),
      [item],
    );

  return (
    <Wrapper>
      {buttonList.map(item => (
        <Radio
          key={`radio-${item.betType}`}
          htmlFor={`betType-${item.betType}`}
          checked={betType === item.betType}
          name="betType"
          disabled={disabled(item)}
          onChange={e => onChange(e.target.checked, item.betType)}
        >
          {getBetTypeName(item.betType)}
        </Radio>
      ))}
    </Wrapper>
  );
};

export default BetTypeRadio;
